












































































































































































































import {
  Vue, Component, Prop, PropSync, Watch,
} from 'vue-property-decorator';
import { mask } from 'vue-the-mask';
import { cloneDeep, forEach } from 'lodash';
import {
  PartnersApi, FilesApi, DocumentRequest, Document,
} from '@compassdigital/foodworks.ts.sdk';
import { mixins } from 'vue-class-component';
import RestaurantInformation from '@/components/Form/Partner/RestaurantInformation/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import EditConfirmation from '@/components/Form/EditConfirmation/index.vue';
import AuditTable from '@/components/Table/AuditTable/index.vue';
import CustomDropdown from '@/components/Form/CustomDropdown/index.vue';
import RestaurantAuditForm from '@/components/Form/Partner/RestaurantAuditForm/index.vue';
import PermissionMixin from '@/mixins/PermissionMixin';
import Format from '@/util/Format';
import AppModule from '@/store/modules/app';
import ToastModule from '@/store/modules/toast';
import Service from '@/util/ServiceUtil';
import UserModule from '@/store/modules/user';
import { IMarketRestaurantInfo } from '@/interface/marketInfo';

@Component({
  components: {
    RestaurantInformation,
    Textfield,
    CustomDropdown,
    EditConfirmation,
    RestaurantAuditForm,
  },
  directives: { mask },
})
export default class RestaurantEdit extends mixins(PermissionMixin) {
  @PropSync('restaurantInfo', {}) readonly restaurantInfoLocal!: any;

  private document: Array<DocumentRequest> | null = null;

  public edit: boolean = false;

  public saving: boolean = false;

  public loading: boolean = false;

  public auditFormError: boolean = false;

  public cacheRestaurant: IMarketRestaurantInfo = {};

  private marketInfo: any = {
    partnerType: 'restaurant',
  };

  get businessNumber() {
    this.getDocumentInfo();
    if (this.restaurantInfoLocal) {
      const { phone } = this.restaurantInfoLocal.businessNumber;
      return Format.maskPhoneNumber(phone);
    }
    return '';
  }

  public async getDocumentInfo() {
    if (this.restaurantInfoLocal.auditFormId) {
      const { auditFormId } = this.restaurantInfoLocal;
      try {
        const api = new FilesApi(AppModule.apiConfig);
        const file = await api.getFile(auditFormId);
        const { documents } = file.data as any;
        this.document = documents;
      } catch (err) {
        throw err;
      }
    }
  }

  public async onDeleteDocument(document: Document) {
    try {
      this.saving = true;
      const documentID = document.id;
      const api = new FilesApi(AppModule.apiConfig);
      const res = await api.deleteFile(documentID as string);
      if (res.status === 200) {
        this.document = null;
      }
    } catch (error) {
      const { message } = error.response.data.error;
      ToastModule.setToast({
        message,
        timeout: 5000,
      });
    }
    this.saving = false;
  }

  get addressLine() {
    let line = '';
    if (this.restaurantInfoLocal) {
      const {
        address = '', city = '', state = '', country = '', zip = '', suite = '',
      } = this.restaurantInfoLocal.address;
      line = `${address} ${suite} ${address || suite ? '</br>' : ''} ${city}${city ? ',' : ''} ${state} ${zip} ${city || state || zip ? '</br>' : ''} ${country}`;
    }
    return line;
  }

  public onEdit() {
    this.cacheRestaurant = cloneDeep(this.restaurantInfoLocal);
    this.edit = true;
  }

  public onCancel() {
    this.edit = false;
  }

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }

  public async onSave() {
    this.auditFormError = false;
    if (
      (this.$refs.form as any).validate()
      && this.restaurantInfoLocal !== null
    ) {
      this.saving = true;
      try {
        const restInfo: any = { ...this.restaurantInfoLocal };
        const { phone } = restInfo.businessNumber;
        if (phone) {
          restInfo.businessNumber.phone = Format.CheckMaskNumber(phone);
        } else {
          restInfo.businessNumber.phone = Number(
            restInfo.businessNumber.phone,
          );
        }

        const cuisines: any = [];
        cuisines.push(restInfo.cuisineTypes);
        restInfo.cuisineTypes = cuisines;

        const locationFood: any = [];
        let locationFoodOther = '';
        if (restInfo.foodPrepLocation) {
          const location = restInfo.foodPrepLocation;
          if (location === 'Others') {
            locationFoodOther = restInfo.foodPrepLocOther;
            restInfo.foodPrepLocOther = locationFoodOther;
          }
          locationFood.push(restInfo.foodPrepLocation);
          restInfo.foodPrepLocation = locationFood;
        }

        try {
          const api = new PartnersApi(AppModule.apiConfig);
          const data = await api.patchPartnerById(restInfo.id, restInfo);
        } catch (error) {
          this.edit = false;
          const { message } = error.response.data.error;
          ToastModule.setToast({
            message,
            timeout: 5000,
          });
        }
        this.edit = false;
      } catch (e) {
        //
      }
      this.saving = false;
    }
  }
}
